const namespace = '[Class]';

export const LOCATION_GET_DISTRICTS = `${namespace} LOCATION GET DISTRICTS`;
export const LOCATION_GET_SCHOOLS = `${namespace} LOCATION GET SCHOOLS`;
export const LOCATION_SET_COUNTRY_PROVINCE = `${namespace} LOCATION SET COUNTRY AND PROVINCE`;
export const LOCATION_SET_PROVINCE = `${namespace} LOCATION SET PROVINCE`;
export const LOCATION_SET_COUNTRY = `${namespace} LOCATION SET COUNTRY`;
